<div class="w-full py-3 px-2 lg:px-4">
  <div class="sm:flex items-center justify-between mb-4">
    <div class="flex items-center justify-start gap-1 lg:gap-2 mb-3 lg:mb-0">
      <!-- Back Button SVG (clickable) -->
      <svg class="size-6 cursor-pointer" [routerLink]="['/admin-panel/set-type']" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">

        <mask id="mask0_848_1764" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <rect width="24" height="24" fill="#C19725" />
        </mask>
        <g mask="url(#mask0_848_1764)">
          <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725" />
        </g>
      </svg>
      <img class="size-6 sm:size-8 lg:size-10" src="/assets/images/rate-list/rate-list.png" alt="Rate List">
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">Rate List Generator</span>
    </div>
  </div>

  <form [formGroup]="rateListGeneratorForm">

    <div class="w-full flex justify-center mt-4 mb-2">
      <div class="w-max">
        <app-custom-select label="Select Customer Type" [options]="customerType" formControlName="rlg_customer_type"
          (keydown.enter)="focusNext($event)" [(selected)]="selectedCustomer" selectId="customerType">
        </app-custom-select>
          <!-- Validation Error (NO layout change) -->
  <div *ngIf="
      rateListGeneratorForm.get('rlg_customer_type')?.invalid &&
      rateListGeneratorForm.get('rlg_customer_type')?.touched
    " class="text-red-500 text-xs mt-1">
    *Customer type is required
  </div>
      </div>
    </div>
    <div class="w-full md:flex py-4 bg-[#FFFFF6] rounded-md ">
      <div
        class="w-full px-3 grid grid-cols-2 sm:grid-cols-5 md:grid-cols-4 lg:grid-cols-10 xl:grid-cols-10 2xl:grid-cols-19 gap-2 sm:gap-2.5 lg:gap-3 space-y-0.5">

        <div class="col-span-2 sm:col-span-1 lg:col-span-2 2xl:col-span-2">
          <!-- <app-custom-select label="Product Type" [options]="productType" formControlName="rlg_product_type"
            (keydown.enter)="focusNext($event)" [(selected)]="selectedProduct" selectId="productType">
          </app-custom-select> -->
          <select formControlName="rlg_product_type" id="" class="block px-2 py-2 w-full text-sm text-444 bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer">
            <option value="" selected disabled hidden>Select Type</option>
            <option value="Assembly">Assembly</option>
            <option value="Master">Ready Product</option>
          </select>
          <div *ngIf="
  rateListGeneratorForm.get('rlg_product_type')?.invalid &&
  rateListGeneratorForm.get('rlg_product_type')?.touched
" class="text-red-500 text-xs mt-1">
  *Product Type is required
</div>
        </div>

        <div class="col-span-2 sm:col-span-2 lg:col-span-3 xl:col-span-3">
          <!-- <app-custom-select 
                    label="Product Categories" 
                    [options]="prodCategory"
                    formControlName="rlg_product_category"
                    [(selected)]="selectedProdCategory"
                    (selectedChange)="onCategoryChange($event)"
                    selectId="prodCategory"
                    [readonly]="true">
                </app-custom-select> -->

          <div class="relative">
            <select autocomplete="off" (keydown.enter)="focusNext($event)" id="prod-category"
              formControlName="rlg_product_category"
              class="block px-2 py-2 w-full text-sm text-444 bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer">
              <option value="" hidden disabled selected>Select Category</option>
              <option *ngFor="let cat of prodCategory" [value]="cat.value">
                {{ cat.label }}{{ cat.subtype ? ' #' + cat.subtype : '' }}
              </option>
            </select>

            <label for="prod-category" class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
                           peer-placeholder-shown:scale-100 peer-placeholder-shown:top-1/2
                           peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
              Product Categories
            </label>
          </div>
          <!-- Validation Error (NO layout change) -->
<div *ngIf="
  rateListGeneratorForm.get('rlg_product_category')?.invalid &&
  rateListGeneratorForm.get('rlg_product_category')?.touched
" class="text-red-500 text-xs mt-1">
  *Product category is required
</div>
        </div>

        <div class="col-span-2 sm:col-span-1 2xl:col-span-2" *ngIf="selectedUnit === 'By Gram'">
          <div class="relative">
            <input type="text" id="rlg_code" formControlName="rlg_code" (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="rlg_code"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white 
                           px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Code</label>
          </div>
          <div *ngIf="
  rateListGeneratorForm.get('rlg_code')?.invalid &&
  rateListGeneratorForm.get('rlg_code')?.touched
" class="text-red-500 text-xs mt-1">
  *Code  is required
</div>
        </div>

        <div class="col-span-2 sm:col-span-1 md:col-span-2 2xl:col-span-2">
          <app-custom-select label="Unit" [options]="unitType" [(selected)]="selectedUnit" formControlName="rlg_unit"
            selectId="unitType" (keydown.enter)="focusNext($event)">
          </app-custom-select>
        </div>

        <div class="col-span-2 sm:col-span-2 2xl:col-span-2" *ngIf="selectedUnit === 'By Gram'">
          <app-custom-select label="Weight Range" [options]="wtRange" [(selected)]="selectedRange"
            formControlName="rlg_weight_range" selectId="wtRange" (keydown.enter)="focusNext($event)">
          </app-custom-select>
          <!-- Validation Error (NO layout change) -->
  <div *ngIf="
      rateListGeneratorForm.get('rlg_weight_range')?.invalid &&
      rateListGeneratorForm.get('rlg_weight_range')?.touched
    " class="text-red-500 text-xs mt-1">
    *Weight range is required
  </div>
        </div>

        <div
          class="col-span-2 sm:col-span-3 lg:col-span-5 xl:col-span-4 2xl:col-span-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-3"
          *ngIf="selectedUnit === 'By Gram'">
          <div class="col-span-1 w-full">
            <div class="flex items-center gap-2">
              <div *ngIf="minRange" class="relative">
                <input type="number" id="rlg_min_weight_range" formControlName="rlg_min_weight_range"
                  (keydown.enter)="focusNext($event)"
                  class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white
                      rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer" placeholder=" " />
                <label for="rlg_min_weight_range" class="absolute text-sm lg:text-sm text-[#898989] duration-300
                      transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white 
                      
                      px-1.5 peer-focus:px-1.5 peer-focus:text-c19725
                      peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2
                      peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75
                      peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                  Min
                </label>
              </div>
          <!-- Validation Error -->
<div *ngIf="
  (rateListGeneratorForm.get('rlg_min_weight_range')?.invalid &&
   rateListGeneratorForm.get('rlg_min_weight_range')?.touched) ||
  rateListGeneratorForm.errors?.['minGreaterThanMax']
" class="text-red-500 text-xs mt-1">

  <!-- Required -->
  <span *ngIf="rateListGeneratorForm.get('rlg_min_weight_range')?.errors?.['required']">
    *Minimum weight is required
  </span>

  <!-- Negative value -->
  <span *ngIf="rateListGeneratorForm.get('rlg_min_weight_range')?.errors?.['min']">
    *Minimum weight cannot be negative
  </span>

  <!-- Min > Max error -->
  <span *ngIf="rateListGeneratorForm.errors?.['minGreaterThanMax']">
    *Minimum weight must be less than maximum weight
  </span>

</div>

              <div *ngIf="showBelow" class="flex items-center gap-2 mt-2">
                <input type="checkbox" formControlName="rlg_below" class="h-4 w-4" />
                <span>Below</span>
              </div>

              <!-- <div *ngIf="maxRange" class="relative">
                <input type="number" id="rlg_max_weight_range" formControlName="rlg_max_weight_range"
                  (keydown.enter)="focusNext($event)"
                  class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white
                      rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer" placeholder=" " />
                <label for="rlg_max_weight_range" class="absolute text-sm lg:text-sm text-[#898989] duration-300
                      transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white 
                      
                      px-1.5 peer-focus:px-1.5 peer-focus:text-c19725
                      peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2
                      peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75
                      peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                  Max
                </label>
              </div> -->
            </div>

          </div>
          <div class="col-span-1">
            <div class="flex items-center gap-2">
              <!-- <div *ngIf="showBelow" class="flex items-center gap-2 mt-2">
                <input type="checkbox" formControlName="rlg_below" class="h-4 w-4" />
                <span>Below</span>
              </div> -->

               <div *ngIf="maxRange" class="relative">
                <input type="number" id="rlg_max_weight_range" formControlName="rlg_max_weight_range"
                  (keydown.enter)="focusNext($event)"
                  class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white
                      rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer" placeholder=" " />
                <label for="rlg_max_weight_range" class="absolute text-sm lg:text-sm text-[#898989] duration-300
                      transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white 
                      
                      px-1.5 peer-focus:px-1.5 peer-focus:text-c19725
                      peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2
                      peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75
                      peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                  Max
                </label>
              </div>
              <div *ngIf="
  (rateListGeneratorForm.get('rlg_max_weight_range')?.invalid &&
   rateListGeneratorForm.get('rlg_max_weight_range')?.touched) ||
  rateListGeneratorForm.errors?.['minGreaterThanMax']
" class="text-red-500 text-xs mt-1">

  <span *ngIf="rateListGeneratorForm.get('rlg_max_weight_range')?.errors?.['required']">
    *Maximum weight is required
  </span>

  <span *ngIf="rateListGeneratorForm.get('rlg_max_weight_range')?.errors?.['min']">
    *Maximum weight cannot be negative
  </span>

  <span *ngIf="rateListGeneratorForm.errors?.['minGreaterThanMax']">
    *Maximum weight must be greater than minimum weight
  </span>

</div>

              <div *ngIf="showAbove" class="flex items-center space-x-2 mt-2">
                <input type="checkbox" formControlName="rlg_above" class="h-4 w-4" />
                <span>Above</span>
              </div>

            </div>
          </div>

        </div>

        <div class="col-span-2 lg:col-span-3 xl:col-span-2 2xl:col-span-3" *ngIf="selectedUnit === 'By Gram'">
          <div class="relative">
            <input type="number" id="rlg_making_charges" formControlName="rlg_per_gm_labour"
              (keydown.enter)="focusNext($event)"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="rlg_making_charges"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white 
                     px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Per Gram Labour
            </label>
          </div>
          <!-- Validation Error -->
  <div *ngIf="
    rateListGeneratorForm.get('rlg_per_gm_labour')?.invalid &&
    rateListGeneratorForm.get('rlg_per_gm_labour')?.touched
  " class="text-red-500 text-xs mt-1">

    <span *ngIf="rateListGeneratorForm.get('rlg_per_gm_labour')?.errors?.['required']">
      *Per gram labour is required
    </span>

    <span *ngIf="rateListGeneratorForm.get('rlg_per_gm_labour')?.errors?.['min']">
      *Labour must be at least 1
    </span>

  </div>
        </div>

        <div class="col-span-2 sm:col-span-1 lg:col-span-2" *ngIf="selectedUnit === 'By MRP'">
          <div class="relative">
            <input type="number" id="rlg_discount" formControlName="rlg_discount" (keydown.enter)="focusNext($event)"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="rlg_discount"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white 
                     px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Discount
            </label>
          </div>
          <!-- Validation Error -->
  <div *ngIf="
    rateListGeneratorForm.get('rlg_discount')?.invalid &&
    rateListGeneratorForm.get('rlg_discount')?.touched
  " class="text-red-500 text-xs mt-1">

    <span *ngIf="rateListGeneratorForm.get('rlg_discount')?.errors?.['required']">
      *Discount is required
    </span>

    <span *ngIf="rateListGeneratorForm.get('rlg_discount')?.errors?.['min']">
      *Discount must be greater than 0
    </span>

  </div>
        </div>

        <div class="col-span-2 sm:col-span-1 lg:col-span-2" *ngIf="selectedUnit === 'By Silver Rate'">
          <div class="relative">
            <input type="number" id="rlg_purity" formControlName="rlg_purity" (keydown.enter)="focusNext($event)"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="rlg_purity"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white 
                   px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Tunch</label>
          </div>
           <!-- Validation Error -->
  <div *ngIf="
    rateListGeneratorForm.get('rlg_purity')?.invalid &&
    rateListGeneratorForm.get('rlg_purity')?.touched
  " class="text-red-500 text-xs mt-1">

    <span *ngIf="rateListGeneratorForm.get('rlg_purity')?.errors?.['required']">
      *Tunch is required
    </span>

    <span *ngIf="rateListGeneratorForm.get('rlg_purity')?.errors?.['min']">
      *Tunch must be greater than 0
    </span>
  </div>
        </div>

        <div class="col-span-1 lg:col-span-2 xl:col-span-1 2xl:col-span-2">
          <div class="flex items-center justify-end gap-2">
            <button type="button" (click)="onSubmit()" *ngIf="addbutton">
              <svg fill="#0BB60B" viewBox="0 0 56.00 56.00" xmlns="http://www.w3.org/2000/svg" stroke="#0BB60B"
                class="cursor-pointer size-10">
                <g id="SVGRepo_bgCarrier" stroke-width="0" transform="translate(9.52,9.52), scale(0.66)">
                  <rect x="0" y="0" width="56.00" height="56.00" rx="0" fill="#ffffff" strokewidth="0">
                  </rect>
                </g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M 13.7851 49.5742 L 42.2382 49.5742 C 47.1366 49.5742 49.5743 47.1367 49.5743 42.3086 L 49.5743 13.6914 C 49.5743 8.8633 47.1366 6.4258 42.2382 6.4258 L 13.7851 6.4258 C 8.9101 6.4258 6.4257 8.8398 6.4257 13.6914 L 6.4257 42.3086 C 6.4257 47.1602 8.9101 49.5742 13.7851 49.5742 Z M 27.9882 39.6367 C 26.6523 39.6367 25.9492 38.6758 25.9492 37.3164 L 25.9492 30.0274 L 18.2617 30.0274 C 16.8788 30.0274 15.9179 29.3008 15.9179 28.0118 C 15.9179 26.6758 16.8320 25.9258 18.2617 25.9258 L 25.9492 25.9258 L 25.9492 18.1680 C 25.9492 16.8086 26.6523 15.8477 27.9882 15.8477 C 29.2773 15.8477 30.0742 16.7617 30.0742 18.1680 L 30.0742 25.9258 L 37.7851 25.9258 C 39.2148 25.9258 40.1054 26.6758 40.1054 28.0118 C 40.1054 29.3008 39.1679 30.0274 37.7851 30.0274 L 30.0742 30.0274 L 30.0742 37.3164 C 30.0742 38.7227 29.2773 39.6367 27.9882 39.6367 Z">
                  </path>
                </g>
              </svg>
            </button>
            <p *ngIf="editButton" class="flex items-center gap-1 text-sm lg:text-lg text-[#649dcd] font-medium">
              <svg (click)="updateForm()" class="cursor-pointer size-5 lg:size-8" viewBox="0 0 30 30" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <rect width="30" height="30" rx="5" fill="#649dcd" />
                <mask id="mask0_1227_7952" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="3" y="3" width="24"
                  height="24">
                  <rect x="3" y="3" width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_1227_7952)">
                  <path
                    d="M11.6 25.5L9.7 22.3L6.1 21.5L6.45 17.8L4 15L6.45 12.2L6.1 8.5L9.7 7.7L11.6 4.5L15 5.95L18.4 4.5L20.3 7.7L23.9 8.5L23.55 12.2L26 15L23.55 17.8L23.9 21.5L20.3 22.3L18.4 25.5L15 24.05L11.6 25.5ZM12.45 22.95L15 21.85L17.6 22.95L19 20.55L21.75 19.9L21.5 17.1L23.35 15L21.5 12.85L21.75 10.05L19 9.45L17.55 7.05L15 8.15L12.4 7.05L11 9.45L8.25 10.05L8.5 12.85L6.65 15L8.5 17.1L8.25 19.95L11 20.55L12.45 22.95ZM13.95 18.55L19.6 12.9L18.2 11.45L13.95 15.7L11.8 13.6L10.4 15L13.95 18.55Z"
                    fill="white" />
                </g>
              </svg> Edit
            </p>
            <button>
              <svg viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="clearForm()"
                class="cursor-pointer size-8">
                <rect y="0.5" width="30" height="30" rx="5" fill="#BB0000"></rect>
                <path
                  d="M7.06189 17C7.02104 16.6724 7 16.3387 7 16C7 11.5817 10.5817 8 15 8C17.5006 8 19.7332 9.14727 21.2002 10.9442M21.2002 10.9442V8M21.2002 10.9442V10.9999L18.2002 11M22.9381 15C22.979 15.3276 23 15.6613 23 16C23 20.4183 19.4183 24 15 24C12.6106 24 10.4659 22.9525 9 21.2916M9 21.2916V21H12M9 21.2916V24"
                  stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                </path>
              </svg>
            </button>
          </div>
        </div>
      </div>

    </div>
  </form>

  <div class="overflow-x-auto w-full mt-8">
    <table
      class="w-full table border border-b-0 border-[#D9D9D9] border-separate border-spacing-0 bg-white overflow-hidden">
      <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-[15px]">
        <tr>
          <th class="p-2 font-medium text-center border-r border-444 last:border-r-0">No.</th>
          <th class="p-2 font-medium text-left border-r border-444 last:border-r-0">Code </th>
          <th class="p-2 font-medium text-left border-r border-444 last:border-r-0">Customer Type</th>
          <th class="p-2 font-medium text-left border-r border-444 last:border-r-0">Product Type</th>
          <th class="p-2 font-medium text-left border-r border-444 last:border-r-0">Product Category</th>
          <th class="p-2 font-medium text-left border-r border-444 last:border-r-0">Unit</th>
          <th class="p-2 font-medium text-left border-r border-444 last:border-r-0">Per gram Labour</th>
          <th class="p-2 font-medium text-left border-r border-444 last:border-r-0">Tunch</th>
          <th class="p-2 font-medium text-left border-r border-444 last:border-r-0">Discount</th>
          <th class="p-2 font-medium text-left border-r border-444 last:border-r-0">WT Range</th>
          <th class="p-2 font-medium text-left border-r border-444 last:border-r-0">Min.WT Range</th>
          <th class="p-2 font-medium text-left border-r border-444 last:border-r-0">Max.WT Range</th>
          <th class="p-2 font-medium text-center border-r border-444 last:border-r-0">Action</th>
        </tr>
      </thead>
      <tbody class="text-xs sm:text-sm lg:text-base">
        <tr class="text-444" *ngFor="let rate of RateListGeneratorList; let i = index">
          <td class="p-2 border-r border-b border-[#D9D9D9] text-center">{{i+1}}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9]">{{ rate.rlg_code || '-'}}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9]">{{rate.rlg_customer_type}}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9]">{{ rate.rlg_product_type === 'Master' ? 'Ready Product' : rate.rlg_product_type || '-' }}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9]">
            {{ rate?.category?.name ? rate?.category?.name + ' (' + rate?.category?.unit + ')' : '-' }}
          </td>
          <td class="p-2 border-r border-b border-[#D9D9D9]">{{rate.rlg_unit || '-'}}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9]">{{rate.rlg_per_gm_labour || '-'}}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9]">{{rate.rlg_purity || '-'}}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9]">{{rate.rlg_discount || '-'}}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9]">{{rate.rlg_weight_range || '-'}}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9]">{{rate.rlg_below === 'Yes' ? 'Below' :
            rate.rlg_min_weight_range || '-'}}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9]">{{ rate.rlg_above === 'Yes' ? 'Above' :
            rate.rlg_max_weight_range || '-'}}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9] text-center">
            <div class="flex items-center justify-center gap-2 xl:gap-4">
              <button class="cursor-pointer"><svg
                  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                  (click)="patchRateListGenerator(rate.rlg_id)" class="size-5 lg:size-6">
                  <path
                    d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                    stroke="#C19725" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  </path>
                  <path d="M14.7166 9.23962L8.10638 15.8499" stroke="#C19725" stroke-miterlimit="5"
                    stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </button>
              <button class="cursor-pointer">
                <svg viewBox="0 0 24 25" fill="none" (click)="onDelete(rate.rlg_id)" xmlns="http://www.w3.org/2000/svg"
                  class="size-5 lg:size-6">
                  <path d="M10 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round"></path>
                  <path d="M14 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round"></path>
                  <path d="M4 7.5H20" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round"></path>
                  <path d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                    stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  </path>
                  <path d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                    stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  </path>
                </svg></button>
            </div>
          </td>
        </tr>

      </tbody>
    </table>
  </div>

  <div class="flex items-center justify-center mt-4 md:mt-8 space-x-1.5 md:space-x-4">
    <button type="button" (click)="onSaveListClick()"
      class="block cursor-pointer capitalize w-[110px] lg:w-[200px] p-1 md:p-1.5 text-base xl:text-lg font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">
      Save List
    </button>
  </div>

</div>